/*
 * Durandal dialog plugin uses javascript to calculates dialog position before openinging it
 * it adds margins in a style attribute, causing css nightmare
 *
 * This extension, adds "responsive" positioning to dialogs. Bassically forced them to add a
 * window resize event listener, before they open, and removing it when dialog is closed
 *
 * To include this functionality in your custom dialog require this file, and such
 * `var responsiveDialog = require('dialog-helper/responsive');`
 *
 * and add the following in your compositionComplete call back
 *
 * ```
 * self.compositionComplete = function () {
 *   responsiveDialog('.past-meeting-report', self);
 * };
 * ```
 *
 * This will take care of adding event listener on activation, and removing it, once the dialog is destroyed.
 *
 * @param {string} modalSelector - string representation of jQuery selector for your custom dialog
 * @param {{}} viewModel - view-model for your custom dialog
 */
define('dialog-helper/responsive',['require','exports','module','plugins/dialog'],function (require, exports, module) {
    var dialog = require('plugins/dialog');

    module.exports = function (viewModel, child) {
        var adjustModal = function () {
            dialog.getDialog(viewModel).context.reposition(child);
        };

        window.addEventListener('resize', adjustModal);

        var originalDeactivate = viewModel.deactivate;
        viewModel.deactivate = function () {
            window.removeEventListener('resize', adjustModal);
            if (originalDeactivate) {
                originalDeactivate.apply(viewModel, arguments);
            }
        };
    };
});

